import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Tooltip ,
  NavItem,
  TabPane,
  NavLink,
  Nav,
  TabContent,
  Container,
  Row,
  Col,
} from "reactstrap";
import GS_DataCollection from "./GS_DataCollection";
import GS_ProcessPipelines from "./GS_ProcessPipelines";
import GS_Central_Data_Collection from "./GS_Central_Data_Collection";

function GettingStarted({userWantInfoAgain,setUserWantInfoAgain}) {
  
  const [tabId, setTabId] = useState("3");
  const whichTabIsActive = [false, false, true];
  const [tabActive, setTabActive] = useState(whichTabIsActive);
  const activeTab = (id) => {
    setTabId(id);
    var newtTabActive = [false,false, false, false,false];
    newtTabActive[id-1] = true;
    setTabActive(newtTabActive);
  };
  console.log("tab id",tabId)
  return (
    <div>
<Nav tabs style={{border:'none',marginBottom:0}}>
  <NavItem>
                  <NavLink
                    className={tabActive[2] ? "active" : ""}
                    onClick={() => activeTab("3")}
                    href="#"
                    style={{ color: tabActive[2]?"#22762B":"#C2C2C2", paddingLeft: 0,fontWeight:600,border:'none' }}
                  >
                    <h6 className="dashboard-nav-tabs">&nbsp; &nbsp;Targeted Campaigns&nbsp;</h6>
                  </NavLink>
                </NavItem>
<NavItem>
                  <NavLink
                    className={tabActive[1] ? "active" : ""}
                    onClick={() => activeTab("2")}
                    href="#"
                    style={{ color: tabActive[1]?"#22762B":"#C2C2C2", paddingLeft: 0,fontWeight:600,border:'none' }}
                  >
                    <h6 className="dashboard-nav-tabs">&nbsp; &nbsp;Open Campaigns&nbsp;</h6>
                  </NavLink>
                </NavItem>
              <NavItem>
                  <NavLink
                    className={tabActive[0] ? "active" : ""}
                    onClick={() => activeTab("1")}
                    href="#"
                    style={{ color: tabActive[0]?"#22762B":"#C2C2C2", paddingLeft: 0,fontWeight:600,border:'none'  }}
                  >
                    <h6 className="dashboard-nav-tabs">&nbsp; &nbsp;Archived&nbsp;Campaigns</h6>
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent style={{ paddingTop: 20 }} activeTab={tabId}>
                     <TabPane tabId="3" style={{ marginBottom: 100 }}>
                <GS_Central_Data_Collection userWantInfoAgain={userWantInfoAgain} setUserWantInfoAgain={setUserWantInfoAgain}/>
              </TabPane>
              <TabPane tabId="1" style={{ marginBottom: 100 }}>
                <GS_DataCollection userWantInfoAgain={userWantInfoAgain} setUserWantInfoAgain={setUserWantInfoAgain}/>
              </TabPane>
              <TabPane tabId="2" style={{ marginBottom: 100 }}>
                <GS_ProcessPipelines userWantInfoAgain={userWantInfoAgain} setUserWantInfoAgain={setUserWantInfoAgain}/>
              </TabPane>
              </TabContent>

    </div>
  )
}

export default GettingStarted
